<style scoped>
.paid-reg {
  display: inline-block;
  background: #28c76f;
  padding: 5px 15px;
  border-radius: 5px;
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 600;
  margin: 0 auto;
}
h2.cms-custom-heading {
  font-weight: 600;
  font-size: 24px;
  font-family: "Poppins", sans-serif;
  color: #001d4e;
}
h1.cms-custom-heading {
  font-weight: 600;
  font-size: 28px;
  font-family: "Poppins", sans-serif;
  color: #000;
}
.custom-head-wrap {
  padding-bottom: 1.25rem;
  border: 1px solid transparent;
  border-bottom: 1px solid #dfdfdf;
  padding: 10px 0;
  transition: all 0.4s;
}
/* .over-right-side-box {
  width: 32%;
  margin-right: 30px;
} */
.over-right-side-box:last-child {
  margin-right: 0;
}
.preview-btn {
  display: inline-block;
  border: 1px solid #4c8bf6;
  border-radius: 5px;
  padding: 8px 15px;
  background: rgb(76, 139, 246);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  font-weight: 600;
}
.success-confetti {
  background: url(../../assets/images/confetti-event-success.png) no-repeat top
    center / 100%;
  padding: 60px 0 0;
}
.success-class {
  margin: 30px 0 70px;
}
.success-class h2 {
  font-size: 28px;
}
.success-class span {
  background: #00a865;
  display: inline-flex;
  height: 60px;
  width: 60px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-bottom: 30px;
}
.success-class span img {
  width: 30px;
  height: 30px;
}
.overview-c-box-wrapper {
  border-radius: 10px;
  padding: 10px;
  border: 1px solid #efefef;
  background: #ffffff;
}
.overview-c-box-wrapper .overview-c-box-wrapper-inner {
  padding: 0 15px 15px 15px;
}
.overview-c-box-wrapper .create {
  margin: 15px 0 0;
}
.overview-c-box-wrapper h3 {
  font-weight: bold;
  font-size: 22px;
}
.overview-c-box-wrapper label {
  font-size: 35px;
  line-height: 1;
  text-align: right;
  font-weight: 500;
  color: #000000;
}
.overview-c-box-wrapper label span {
  font-weight: 300;
  display: block;
  font-size: 14px;
  text-transform: uppercase;
}
.overview-c-box-wrapper .create {
  font-weight: 300;
}
.overview-c-box-wrapper .tag-type {
}
.overview-c-box-wrapper {
  height: calc(100% - 30px);
  margin-bottom: 30px;
}

.arrow-up {
  transform: rotate(180deg);
}

.overview-c-box-wrapper .tag-type .tag-link {
  border: 0;
  padding: 5px 33px 5px 15px;
  background-color: #ffe8daa1;
  color: #000000;
  border-radius: 25px;
  font-size: 14px;
  position: relative;
  display: inline-block;
  margin: 2px 5px 2px 0;
}
.tag-type .tag-link .iconsize.feather-icon {
  position: absolute !important;
  right: 7px;
  top: 50%;
  transform: translateY(-50%);
}
.tag-type .tag-link .iconsize.feather-icon svg {
  width: 18px;
}

.overview-c-box-wrapper h3 {
  min-height: 52px;
}
.overflow-row .vx-col:nth-child(2) .overview-c-box-wrapper .tag-link {
  background-color: #e6e088a8;
}
.overflow-row .vx-col:nth-child(3) .overview-c-box-wrapper .tag-link {
  background-color: #cff2cba8;
}
.overflow-row .vx-col:nth-child(4) .overview-c-box-wrapper .tag-link {
  background-color: #cddeffa8;
}
.overflow-row .vx-col:nth-child(5) .overview-c-box-wrapper .tag-link {
  background-color: #b2ebe0a8;
}
.overflow-row .vx-col:nth-child(6) .overview-c-box-wrapper .tag-link {
  background-color: #f3d1dca8;
}
.overflow-row .vx-col:nth-child(7) .overview-c-box-wrapper .tag-link {
  background-color: #ffccf9a8;
}
.overflow-row .vx-col:nth-child(8) .overview-c-box-wrapper .tag-link {
  background-color: #ecdaffa8;
}
.over-right-side-box {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 4px 4px 0px rgb(0 0 0 / 12%);
  margin-bottom: 30px;
  background: #ffffff;
  height: 100%;
}
.over-right-side-box .over-t-head {
  color: #252d3a;
  font-size: 16px;
  font-weight: 500;
  background-color: #ffffff;
}
.over-right-side-box a {
  font-size: 16px;
  font-weight: 500;
  color: #4c8bf6;
}
.over-dark-bg {
  background-color: #252d3a;
}
.over-right-side-box .over-r-des {
  color: #000000;
  font-size: 15px;
  font-weight: 300;
  margin-bottom: 12px;
}
.over-dark-bg.over-right-side-box .over-r-des {
  color: #ffffff;
}
.over-copy {
  position: absolute;
  bottom: auto;
  top: 50%;
  right: 5px;
  left: auto;
  cursor: pointer;
  z-index: 9;
  transform: translateY(-50%);
}
.over-right-side-box .form-group input {
  width: 100%;
  height: 45px;
  border-radius: 5px;
  border: 1px solid #dfe0e5;
  padding: 5px 30px 5px 8px;
  font-size: 12px;
}

.input-label {
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: 500;
}
.overview-c-box-wrapper .fa-cog {
  opacity: 0.4;
  font-size: 20px;
}
.d-flex {
  display: flex;
}
.justify-content-between {
  justify-content: space-between;
}
.form-group {
  margin-bottom: 1rem;
}
.position-relative {
  position: relative;
}
.overview-msg {
  background: #faf5db;
  border: 1px solid #f2de78b7;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 110px;
}
.overview-msg p {
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  color: #000;
}
.over-link-hld ul {
  padding-left: 15px;
}
.over-link-hld li {
  margin-bottom: 10px;
  list-style-type: disc;
}
.over-link-hld li a {
  font-size: 16px;
  color: #4c8bf6;
  font-weight: 500;
}
.over-link-hld li .feather-icon svg {
  width: 18px;
}
.edit-hide {
  opacity: 0;
}
.over-link-hld li:hover .edit-hide {
  opacity: 1;
}
span.overlink-edit {
  float: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.overview-c-box-wrapper .overview-c-box-wrapper-inner img {
  opacity: 0.5;
}
#custom-tooltip-reg {
  display: none;
  float: right;
  margin-top: -37px;
  margin-right: 10px;
  padding: 5px 12px;
  background-color: #ffffff;
  border-radius: 4px;
  color: #000000;
  text-align: center;
}
.pointer {
  cursor: pointer;
}
.hidden-icon {
  visibility: hidden;
}
.pointer-default {
  cursor: default;
}
.for-dropdown {
  position: relative;
  display: inline-block;
}
.session-dropdowns {
  position: absolute;
  width: 250px;
  min-height: 200px;
  background: #fff;
  z-index: 999;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.4);
  padding: 15px;
  border-radius: 5px;
  top: 100%;
  left: 0;
  margin-top: 10px;
}
.session-dropdowns ul li {
  padding: 10px 0 10px 0px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #dfdfdf;
  cursor: pointer;
}
.session-dropdowns ul li:last-child {
  border-bottom: none;
}
</style>
<style>
.vue-back-to-top {
  display: none !important;
}
.overview-mail-settings.con-vs-popup .vs-popup {
  width: 1400px !important;
}
.v-step {
  background: #19191d !important;
}

.v-step__button-skip {
  background: #393a3e !important;
  width: 30% !important;
}

.v-step__button-next {
  background: #1a73e8 !important;
  width: 30% !important;
}
.v-step__button-stop {
  background: #1a73e8 !important;
  width: 30% !important;
}
.over-link-hld .con-vs-tooltip {
  cursor: pointer;
}
.v-step {
  border-radius: 10px !important;
}
.v-step__header {
  border-radius: 10px 10px 0 0 !important;
}
.v-step__button {
  font-size: 1rem !important;
  height: 2.5rem !important;
}
.v-step__button:hover {
  color: #fff !important;
}
.v-step__button:hover {
  background-color: inherit !important;
}
/* drop-arrow */
.down-arrow-btn {
  position: fixed;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
}
.down-arrow-btn a {
  display: inline-flex;
  height: 60px;
  width: 60px;
  background: rgba(76, 139, 246, 0.6);
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.down-arrow-btn a span {
  color: #fff;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.down-arrow-btn a svg.feather.feather-chevron-down {
  height: 30px;
  width: 30px;
}
/* Custom Animate.css */
.back-shadow {
  width: 120px;
  height: 120px;
  background: rgba(67, 117, 201, 0.8);
  opacity: 0.5;
  border-radius: 50%;
  position: absolute;
  left: -50%;
  top: -50%;
  z-index: -1;
  animation: blinker 2s linear infinite;
}
@keyframes blinker {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: scale(0.5);
  }
  100% {
    opacity: 0;
    transition: all 2s;
  }
}
.v-step__button-previous:hover {
    background: #1a73e8 !important;
}
</style>
<template>
  <div class="container-fluid" @click="hidePopup">
    <div class="down-arrow-btn">
      <a id="arrow-icon" href="javascript:void(0)" @click="scrollScreen()">
        <feather-icon class="" icon="ChevronDownIcon" />
      </a>
      <div class="back-shadow"></div>
    </div>
    <div class="overview-msg" v-if="!showUnPublishBanner">
      <p><feather-icon class="mr-5" icon="EditIcon" /></p>
      <p>
        Event is in <b>Review mode.</b> Only Event <b>Admins</b> can access the
        preview of the event, attendees will not be able to access the page
        until it is published
      </p>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col w-full lg:w-12/12 lg:mt-0">
        <div
          class="flex flex-wrap items-center justify-end"
          v-if="Session_Event_Id && UserRole == 2"
        >
          <small class="mr-2"
            ><b
              >Event Status:
              {{ EventIsPublished ? "Published" : "Under-Review" }}</b
            ></small
          >
          <vs-switch
            v-model="EventIsPublished"
            v-on:click="beforeUnPublishConfirmation"
          >
          </vs-switch>
        </div>
      </div>
    </div>
    <div class="vx-row mt-5">
      <!-- left box area wrapper start -->
      <div class="vx-col w-full lg:w-12/12 lg:mt-0">
        <div class="vx-row overflow-row">
          <div class="vx-col w-full lg:w-1/4 lg:mt-0" v-if="sessionFlg">
            <div class="overview-c-box-wrapper" id="v-step-0">
              <p class="text-right">
                <feather-icon
                  icon="SettingsIcon"
                  svgClasses="w-6 h-6 text-grey pointer"
                  @click="showSettings('Session')"
                ></feather-icon>
              </p>
              <div class="overview-c-box-wrapper-inner">
                <div class="d-flex justify-content-between">
                  <img src="../../assets/images/overview/live.svg" />
                  <label>
                    {{ sessionCount }}
                    <span> Sessions</span>
                  </label>
                </div>
                <!-- <p class="create">Create</p> -->
                <div class="tag-type mt-1 d-inline-block">
                  <h3>Sessions</h3>
                  <a
                    href="javascript:void(0)"
                    class="tag-link my-1 for-dropdown"
                    :style="{ 'background-color': sponsorColor }"
                    @click="openSessionDropdown"
                    >Create
                    <feather-icon
                      class="iconsize"
                      v-if="!sessionDropdown"
                      icon="ChevronRightIcon"
                    />
                    <feather-icon
                      class="iconsize"
                      v-else-if="sessionDropdown"
                      icon="ChevronDownIcon"
                    />
                    <div
                      id="session-dropdowns"
                      class="session-dropdowns"
                      @click="preventSessionPopupHide"
                      v-if="sessionDropdown"
                    >
                      <ul>
                        <li
                          @click="
                            sendToSession({ label: 'Custom Url', value: 5 })
                          "
                        >
                          <feather-icon
                            icon="LinkIcon"
                            svgClasses="h-5 w-5 mr-2"
                            class="mr-2"
                          /><span>Custom Url</span>
                        </li>
                        <li
                          @click="
                            sendToSession({ label: 'In-person', value: 6 })
                          "
                        >
                          <img
                            src="../../assets/images/icons/in-person-dark.svg"
                            style="
                              height: 22px;
                              width: 22px;
                              margin-right: 10px;
                            "
                          /><span>In-Person</span>
                        </li>
                        <li
                          @click="
                            sendToSession({ label: 'Live Panel', value: 3 })
                          "
                        >
                          <img
                            src="../../assets/images/icons/live-panel-dark.svg"
                            style="
                              height: 22px;
                              width: 22px;
                              margin-right: 10px;
                            "
                          /><span>Live Panel (Webinar)</span>
                        </li>
                        <li
                          @click="
                            sendToSession({ label: 'Round Table', value: 4 })
                          "
                        >
                          <img
                            src="../../assets/images/icons/round-table-dark.svg"
                            style="
                              height: 22px;
                              width: 22px;
                              margin-right: 10px;
                            "
                          /><span>Round Tables</span>
                        </li>
                        <li
                          @click="
                            sendToSession({ label: 'Live Stream', value: 2 })
                          "
                        >
                          <img
                            src="../../assets/images/icons/live-stream-dark.svg"
                            style="
                              height: 22px;
                              width: 22px;
                              margin-right: 10px;
                            "
                          /><span>Live Stream</span>
                        </li>
                        <li
                          @click="
                            sendToSession({ label: 'On Demand', value: 1 })
                          "
                        >
                          <img
                            src="../../assets/images/icons/on-demand-dark.svg"
                            style="
                              height: 22px;
                              width: 22px;
                              margin-right: 10px;
                            "
                          /><span>On Demand</span>
                        </li>                        
                      </ul>
                    </div>
                  </a>
                  <a
                    href="javascript:void(0)"
                    class="tag-link my-1"
                    :style="{ 'background-color': sessionColor }"
                    @click="pushToPage('/event/sessions')"
                    >List
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/4 lg:mt-0" v-if="roundtableFlg">
            <div class="overview-c-box-wrapper" id="v-step-1">
              <p class="text-right">
                <feather-icon
                  icon="SettingsIcon"
                  svgClasses="w-6 h-6 text-grey pointer"
                  @click="showSettings('Roundtable')"
                ></feather-icon>
              </p>
              <div class="overview-c-box-wrapper-inner">
                <div class="d-flex justify-content-between">
                  <img src="../../assets/images/overview/rt.svg" />
                  <label>
                    {{ roundtableCount }}
                    <span> Round Tables</span>
                  </label>
                </div>
                <!-- <p class="create">Create</p> -->
                <div class="tag-type mt-1 d-inline-block">
                  <h3>Round Tables</h3>
                  <a
                    href="javascript:void(0)"
                    class="tag-link my-1"
                    @click="pushToPage('/event/roundtable/add')"
                    :style="{ 'background-color': roundtableColor }"
                    >Create
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                  <a
                    href="javascript:void(0)"
                    class="tag-link my-1"
                    @click="pushToPage('/event/roundtables')"
                    :style="{ 'background-color': roundtableColor }"
                    >List
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                  <a
                    href="javascript:void(0)"
                    class="tag-link my-1"
                    @click="pushToPage('/event/roundtable/seating/')"
                    :style="{ 'background-color': roundtableColor }"
                    >Seating
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                </div>
              </div>
            </div>
          </div>

          <!--single box start-->
          <div class="vx-col w-full lg:w-1/4 lg:mt-0" v-if="attendeeFlg">
            <div class="overview-c-box-wrapper" id="v-step-3">
              <p class="text-right">
                <feather-icon
                  icon="SettingsIcon"
                  svgClasses="w-6 h-6 text-grey pointer"
                  @click="showSettings('Attendee')"
                ></feather-icon>
              </p>
              <div class="overview-c-box-wrapper-inner">
                <div class="d-flex justify-content-between">
                  <img
                    src="../../assets/images/overview/attendee.svg"
                    style="width: 46px; height: 78px"
                  />

                  <label>
                    {{ attendeeCount }}
                    <span> Attendees</span>
                  </label>
                </div>
                <!-- <p class="create">Create</p> -->
                <div class="tag-type mt-1 d-inline-block">
                  <h3>Attendee</h3>
                  <a
                    href="javascript:void(0)"
                    @click="pushToPage('/event/attendee/add')"
                    class="tag-link my-1"
                    :style="{ 'background-color': attendeeColor }"
                    >Create
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                  <a
                    href="javascript:void(0)"
                    @click="pushToPage('/event/attendees')"
                    class="tag-link my-1"
                    :style="{ 'background-color': attendeeColor }"
                    >List
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                  <a
                    href="javascript:void(0)"
                    @click="pushToPage('/event/groups')"
                    class="tag-link my-1"
                    :style="{ 'background-color': attendeeColor }"
                    >Groups
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/4 lg:mt-0" v-if="exhibitorFlg">
            <div class="overview-c-box-wrapper" id="v-step-2">
              <p class="text-right">
                <feather-icon
                  icon="SettingsIcon"
                  svgClasses="w-6 h-6 text-grey pointer"
                  @click="showSettings('Exhibitor')"
                ></feather-icon>
              </p>
              <div class="overview-c-box-wrapper-inner">
                <div class="d-flex justify-content-between">
                  <img src="../../assets/images/overview/booth.svg" />
                  <label>
                    {{ exhibitorCount }}
                    <span> Exhibitors</span>
                  </label>
                </div>
                <!-- <p class="create">Setup</p> -->
                <div class="tag-type mt-1 d-inline-block">
                  <h3>Exhibitor</h3>
                  <a
                    href="javascript:void(0)"
                    class="tag-link my-1"
                    @click="pushToPage('/event/exhibitor/add')"
                    :style="{ 'background-color': exhibitorColor }"
                    >Create
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                  <a
                    href="javascript:void(0)"
                    class="tag-link my-1"
                    @click="pushToPage('/event/exhibitors')"
                    :style="{ 'background-color': exhibitorColor }"
                    >List
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/4 lg:mt-0" v-if="speakerFlg">
            <div class="overview-c-box-wrapper" id="v-step-4">
              <p class="text-right">
                <feather-icon
                  icon="SettingsIcon"
                  svgClasses="w-6 h-6 text-grey pointer"
                  @click="showSettings('Speaker')"
                ></feather-icon>
              </p>
              <div class="overview-c-box-wrapper-inner">
                <div class="d-flex justify-content-between">
                  <img src="../../assets/images/overview/speaker.svg" />
                  <label>
                    {{ speakerCount }}
                    <span> Speakers</span>
                  </label>
                </div>
                <!-- <p class="create">Create</p> -->
                <div class="tag-type mt-1 d-inline-block">
                  <h3>Speaker</h3>
                  <a
                    href="javascript:void(0)"
                    @click="pushToPage('/event/speaker/add')"
                    :style="{ 'background-color': speakerColor }"
                    class="tag-link my-1"
                    >Create
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                  <a
                    href="javascript:void(0)"
                    @click="pushToPage('/event/speakers')"
                    class="tag-link my-1"
                    :style="{ 'background-color': speakerColor }"
                    >List
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                </div>
              </div>
            </div>
          </div>

          <!--single box end-->
          <!--single box start-->

          <!--single box end-->
          <!--single box start-->

          <div class="vx-col w-full lg:w-1/4 lg:mt-0" v-if="meetingFlg">
            <div class="overview-c-box-wrapper" id="v-step-5">
              <p class="text-right">
                <feather-icon
                  icon="SettingsIcon"
                  svgClasses="w-6 h-6 text-grey hidden-icon"
                ></feather-icon>
              </p>
              <div class="overview-c-box-wrapper-inner">
                <div class="d-flex justify-content-between">
                  <img src="../../assets/images/overview/meeting.svg" />
                  <label>
                    {{ meetingCount }}
                    <span> Meetings</span>
                  </label>
                </div>
                <!-- <p class="create">Create</p> -->
                <div class="tag-type mt-1 d-inline-block">
                  <h3>1:1 Meetings</h3>
                  <a
                    href="javascript:void(0)"
                    class="tag-link my-1"
                    @click="pushToPage('/event/meetings')"
                    :style="{ 'background-color': meetingColor }"
                    >List
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/4 lg:mt-0" v-if="sponserFlg">
            <div class="overview-c-box-wrapper" id="v-step-6">
              <p class="text-right">
                <feather-icon
                  icon="SettingsIcon"
                  svgClasses="w-6 h-6 text-grey hidden-icon"
                ></feather-icon>
              </p>
              <div class="overview-c-box-wrapper-inner">
                <div class="d-flex justify-content-between">
                  <img src="../../assets/images/overview/sponsors.svg" />
                  <label>
                    {{ sponserCount }}
                    <span> Sponsors</span>
                  </label>
                </div>
                <!-- <p class="create">Create</p> -->
                <div class="tag-type mt-1 d-inline-block">
                  <h3>Sponsors</h3>
                  <a
                    href="javascript:void(0)"
                    class="tag-link my-1"
                    @click="pushToPage('/event/sponsor/add')"
                    :style="{ 'background-color': sponsorColor }"
                    >Create
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                  <a
                    href="javascript:void(0)"
                    class="tag-link my-1"
                    @click="pushToPage('/event/sponsors')"
                    :style="{ 'background-color': sponsorColor }"
                    >List
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/4 lg:mt-0" v-if="lobbyFlg">
            <div class="overview-c-box-wrapper" id="v-step-7">
              <p class="text-right">
                <feather-icon
                  icon="SettingsIcon"
                  svgClasses="w-6 h-6 hidden-icon"
                ></feather-icon>
              </p>
              <div class="overview-c-box-wrapper-inner">
                <div class="d-flex justify-content-between">
                  <img src="../../assets/images/overview/lobby.svg" />
                  <!-- <label>
                    04
                    <span> Meetings</span>
                  </label> -->
                </div>
                <!-- <p class="create">Setup</p> -->
                <div class="tag-type mt-1 d-inline-block">
                  <h3>Virtual Lobby</h3>
                  <a
                    href="javascript:void(0)"
                    class="tag-link my-1"
                    @click="pushToPage('/event/virtuallobby')"
                    :style="{ 'background-color': lobbyColor }"
                    >Settings
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                  <a
                    href="javascript:void(0)"
                    class="tag-link my-1"
                    @click="pushToPage('/event/photowalls')"
                    :style="{ 'background-color': lobbyColor }"
                    >Photo Wall
                    <feather-icon class="iconsize" icon="ChevronRightIcon"
                  /></a>
                </div>
              </div>
            </div>
          </div>
          <!--single box end-->
          <!--single box start-->
          <!--single box end-->
        </div>
      </div>
      <!-- left box area wrapper end-->
      <!-- right wrapper -->
      <div class="vx-col md:w-1/1 w-full">
        <div class="custom-head-wrap mb-5">
          <h2 class="cms-custom-heading" v-if="allowRegistrationFlg == true">
            Registration and More options
          </h2>
          <h2 class="cms-custom-heading" v-else>More options</h2>
        </div>
      </div>
      <div
        class="
          vx-col
          w-full
          sm:w-1/1
          md:w-1/1
          lg:w-1/1
          xl:w-1/1
          flex
          justify-content-start
        "
      >

        <div class="vx-row w-full">
          <div class="vx-col md:w-4/12">
             <div
          class="over-right-side-box py-3 over-dark-bg"
          v-if="allowRegistrationFlg == true"
        >
          <div
            class="d-flex align-items-center over-t-head pb-3 px-4"
            style="background: #252d3a !important; color: #fff !important"
          >
            <img
              src="../../assets/images/registration.svg"
              class="mr-2"
              alt=""
              style="color: white; height: 24px; width: 26px"
            />
            Registration
          </div>
          <span id="custom-tooltip-reg">copied!</span>
          <div class="px-4" style="text-align: center">
            <p class="over-r-des">
              Use this link to invite people to this event:
            </p>
            <div class="form-group position-relative">
              <input
                readonly
                type="text"
                class=""
                placeholder=""
                :value="newVersionRegLink"
                id="reglink"
              />
              <span
                class="over-copy"
                @click="copyLinkRegistration(newVersionRegLink)"
                ><img src="../../assets/images/overview/copy.svg"
              /></span>
            </div>
            <a
              :href="newVersionRegLink"
              target="_blank"
              style="
                justify-content: center;
                align-items: center;
                display: flex;
              "
              >Go to registration page<feather-icon
                icon="ExternalLinkIcon"
                svgClasses="w-6 h-6 ml-2"
              ></feather-icon
            ></a>

            <a
              href="javascript:void(0)"
              @click="pushToPage('/event/reg-dashboard')"
              class="paid-reg mt-3"
              >DASHBOARD
            </a>

            <!-- <feather-icon
              icon="ArrowRightIcon"
              svgClasses="w-6 h-6 ml-2"
            ></feather-icon> -->
          </div>
        </div>
          
          </div>
          <div class="vx-col md:w-4/12">
             <div class="over-right-side-box pb-3 px-4">
          <div
            class="d-flex align-items-center over-t-head py-3"
            style="border-bottom: 1px solid #252d3a !important"
          >
            <feather-icon
              icon="MailIcon"
              svgClasses="w-6 h-6 mr-2"
            ></feather-icon>
            Setup Mail Template
          </div>
          <div class="mt-2">
            <p class="over-r-des">Quick Link to setup mail template:</p>
            <div class="over-link-hld">
              <ul>
                <li id="v-step-8">
                  <a class="pointer-default" href="javascript:void(0)"
                    >Announcement</a
                  >

                  <span class="overlink-edit">
                    <feather-icon
                      class="ml-2 edit-hide pointer"
                      icon="Edit2Icon"
                      title="Edit Template"
                      @click="
                        openMailTemplate('Announcement', 'AnnouncementMail')
                      "
                    />

                    <vx-tooltip
                      text="Announcement mail is used to inform attendees of an important info related to the event. eg Event starts in 15 mins"
                      position="top"
                    >
                      <feather-icon class="ml-2" icon="InfoIcon" title="Info" />
                    </vx-tooltip>
                  </span>
                </li>
                <li id="v-step-9">
                  <a class="pointer-default" href="javascript:void(0)"
                    >Welcome</a
                  >
                  <span class="overlink-edit">
                    <feather-icon
                      class="ml-2 edit-hide pointer"
                      icon="Edit2Icon"
                      title="Edit Template"
                      @click="openMailTemplate('UserSignup', 'welcomeMail')"
                    />
                    <vx-tooltip
                      text="Welcome Mail is sent after attendees self-register from the e2m Registration portal. Welcome mail usually has the login details with passcode in the mail body."
                      position="top"
                    >
                      <feather-icon class="ml-2" icon="InfoIcon" title="Info" />
                    </vx-tooltip>
                  </span>
                </li>
                <li id="v-step-10">
                  <a class="pointer-default" href="javascript:void(0)"
                    >Attendee Reminder</a
                  >
                  <span class="overlink-edit">
                    <feather-icon
                      class="ml-2 edit-hide pointer"
                      icon="Edit2Icon"
                      title="Edit Template"
                      @click="openMailTemplate('Reminder', 'ReminderMail')"
                    />

                    <vx-tooltip
                      :text="`Reminder mail is used to send message out to attendees with Call to Action what you&#39;d like them to do. eg Registration Confirmation: <Event Name>`"
                      position="top"
                    >
                      <feather-icon
                        class="ml-2"
                        icon="InfoIcon"
                        title="Info"
                        cursor="pointer"
                      />
                    </vx-tooltip>
                  </span>
                </li>
                <li id="v-step-11">
                  <a class="pointer-default" href="javascript:void(0)"
                    >Speaker Reminder</a
                  >
                  <span class="overlink-edit">
                    <feather-icon
                      class="ml-2 edit-hide pointer"
                      icon="Edit2Icon"
                      title="Edit Template"
                      @click="openMailTemplate('Reminder', 'Speaker')"
                    />

                    <vx-tooltip
                      text="Speaker mail template is used to send general information to speakers from the Speaker List screen."
                      position="top"
                    >
                      <feather-icon class="ml-2" icon="InfoIcon" title="Info" />
                    </vx-tooltip>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
          
          
          </div>
          <div class="vx-col md:w-4/12">
              <div class="over-right-side-box pb-3 px-4">
          <div
            class="d-flex align-items-center over-t-head py-3"
            style="border-bottom: 1px solid #252d3a !important"
          >
            <feather-icon
              icon="ListIcon"
              svgClasses="w-6 h-6 mr-2"
            ></feather-icon>

            More Options
          </div>
          <div class="mt-2">
            <p class="over-r-des">Quick Link to setup more options:</p>
            <div class="over-link-hld">
              <ul>
                <li id="v-step-12">
                  <a
                    href="javascript:void(0)"
                    @click="pushToPage('/event/manage-menu')"
                    >Manage Menu</a
                  >
                </li>
                <li id="v-step-13">
                  <a
                    href="javascript:void(0)"
                    @click="pushToPage('/event/resources')"
                    >Manage Resources</a
                  >
                </li>
                <li id="v-step-14">
                  <a
                    href="javascript:void(0)"
                    @click="pushToPage('/event/plugins')"
                    >Setup Plugins</a
                  >
                </li>
                <li id="v-step-15">
                  <a
                    href="javascript:void(0)"
                    @click="pushToPage('/event/notification')"
                    >Alerts & Notifications</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
          </div>
        </div>


        <!-- right-side-box -->
       
        <!-- right-side-box end -->
        <!-- right-side-box -->
       
        <!-- right-side-box end -->
        <!-- right-side-box -->
        
        <!-- right-side-box end -->
      </div>
      <!-- right wrapper end-->
    </div>

    <vs-popup
      class="holamundo publish-event"
      title="   "
      :active.sync="publishEventSuccess"
    >
      <div class="vx-row mb-5 success-confetti">
        <div class="text-center w-full success-class">
          <span><img src="../../assets/images/check-success.svg" /></span>
          <h2>Event has been</h2>
          <h2 class="mb-3">published successfully!</h2>
          <h5 v-if="!disablePreviewBtn">Click below for admin preview</h5>
        </div>
        <div class="text-center w-full" v-if="!disablePreviewBtn">
          <a
            @click="resetModal"
            class="preview-btn"
            target="_blank"
            :href="previewUrl"
            >Preview Now</a
          >
        </div>
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo overview-mail-settings"
      title="Setup Mail Template"
      :active.sync="mailPopUp"
    >
      <mail-template-edit />
    </vs-popup>
    <div v-if="attendeeSettings == true">
      <attendee-settings :data="attendeeSettings" :key="attendeeKey" />
    </div>
    <div v-if="speakerSettings == true">
      <speaker-settings :data="speakerSettings" :key="speakerKey" />
    </div>
    <div v-if="roundtableSettings == true">
      <rt-settings :data="roundtableSettings" :key="roundtableKey" />
    </div>
    <div v-if="sessionSettings == true">
      <session-settings :data="sessionSettings" :key="sessionKey" />
    </div>
    <div v-if="exhibitorSettings == true">
      <exhibitor-settings :data="exhibitorSettings" :key="exhibitorKey" />
    </div>
    <div>
      <v-tour name="myTour" :steps="steps" :options="tourOptions"></v-tour>
    </div>
  </div>
</template>

<script>
import moduleMailtplManagement from "@/store/mailtpl-management/moduleMailtplManagement.js";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import moduleDashboardManagement from "@/store/dashboard/moduleDashboard.js";
import MailTemplateEdit from "../mailtpl/MailtplEditNew.vue";
import ls from "@/common/localStorage";
import { bus } from "../../main";
import Swal from "sweetalert2";
import con from "@/firebase/firebaseInit.ts";
import AttendeeSettings from "../attendee/AttendeeSettings.vue";
import SpeakerSettings from "../speaker/SpeakerSetting.vue";
import RtSettings from "../roundtable/RoundtableSettings.vue";
import SessionSettings from "../session/SessionSettings.vue";
import ExhibitorSettings from "../exhibitors/ExhibitorSettings.vue";

var cn = ls.getSessionEventCollectionName();
const eventInfoRef = con.eventDB.collection(cn).doc("EventInfo");
var vm;
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
let setOverviewWatch;
let counter = 0;
export default {
  data() {
    return {
         tourOptions: {
        labels: {
          buttonSkip: "Skip Tour",
          buttonPrevious: "Previous",
          buttonNext: "Next",
          buttonStop: 'Finish'
        },
      },
      steps: [],
      attendeeFlg: false,
      speakerFlg: false,
      sponserFlg: false,
      sessionFlg: false,
      roundtableFlg: false,
      exhibitorFlg: false,
      meetingFlg: false,
      lobbyFlg: false,
      attendeeCount: null,
      speakerCount: null,
      sponserCount: null,
      sessionCount: null,
      roundtableCount: null,
      exhibitorCount: null,
      meetingCount: null,
      showUnPublishBanner: false,
      mailPopUp: false,
      allowRegistrationFlg: false,
      registrationLink: null,
      attendeeSettings: false,
      attendeeKey: 0,
      speakerKey: 0,
      speakerSettings: false,
      roundtableSettings: false,
      roundtableKey: 0,
      sessionSettings: false,
      sessionKey: 0,
      exhibitorSettings: false,
      exhibitorKey: 0,
      attendeeColor: null,
      sessionColor: null,
      speakerColor: null,
      sponsorColor: null,
      exhibitorColor: null,
      roundtableColor: null,
      meetingColor: null,
      lobbyColor: null,
      sessionDropdown: false,
      Session_Event_FullName: ls.getSessionValueByKey("Session_Event_FullName"),
      Session_Event_Id: ls.getSessionValueByKey("Session_Event_Id"),
      UserRole: ls.getSessionValueByKey("Role"),
      EventIsPublished: false,
      IsEventDataLoaded: false,
      publishEventSuccess: false,
      previewUrl: null,
      isScrolled: false,
      disablePreviewBtn: false,
      GeneralSettings: {RegistrationVersion:1},
    };
  },
  methods: {
    resetModal() {
      this.publishEventSuccess = false;
    },
    scrollScreen() {
      if (this.isScrolled == false) {
        var scrollingElement = document.scrollingElement || document.body;
        $(scrollingElement).animate(
          {
            scrollTop: document.body.scrollHeight,
          },
          500
        );
        $("#arrow-icon").addClass("arrow-up");
        this.isScrolled = true;
      } else {
        var scrollingElement = document.scrollingElement || document.body;
        $(scrollingElement).animate(
          {
            scrollTop: 0,
          },
          500
        );
        $("#arrow-icon").removeClass("arrow-up");
        this.isScrolled = false;
      }
    },
    showResponsivePreview() {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
      let CustomDomain = ls.getSessionValueByKey("CustomDomain");
      this.previewUrl = `https://${CustomDomain}/joincms/${Session_Client_Id}/${Session_Event_Id}/preview`;
    },
    fetchEventMenuData() {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$store
        .dispatch("eventManagement/fetchEventFeatures", Session_Event_Id)
        .then((res) => {
          res.AllFeatures.map((row) => {
            if (row.Name == "Session") {
              this.sessionFlg = row.selected == true ? true : false;
              this.sessionColor = row.color == null ? null : row.color;
              if (this.sessionFlg == true) {
                this.steps.splice(0, 0, {
                  target: "#v-step-0",
                  header: { title: "Create Sessions" },
                  offset: -200,
                  params: { placement: "right" },
                  content:
                    "Choose from 5 different session types that suits your requirement. When a session is live, attendees will be able to see the video streams of designated speakers. Learn more about session types…",
                });
              }
            } else if (row.Name == "Round Table") {
              this.roundtableFlg = row.selected == true ? true : false;
              this.roundtableColor = row.color == null ? null : row.color;
              if (this.roundtableFlg == true) {
                this.steps.splice(1, 0, {
                  target: "#v-step-1",
                  header: { title: "Create Round Tables" },
                  offset: -200,
                  params: { placement: "right" },
                  content:
                    "Set up and access Round tables and boost virtual networking at your event. The recommended max capacity for a web roundtable is 8, and the Zoom option gives upto 1000(subject to license add-ons)",
                });
              }
            } else if (row.Name == "Exhibitor") {
              this.exhibitorFlg = row.selected == true ? true : false;
              this.exhibitorColor = row.color == null ? null : row.color;
              if (this.exhibitorFlg == true) {
                this.steps.splice(2, 0, {
                  target: "#v-step-2",
                  header: { title: "Create an Exhibitor" },
                  offset: -200,
                  params: { placement: "right" },
                  content:
                    "The Expo area is the exhibitor hall of digital vendor booths at your event. You can choose from 3 different types of Expo Halls and from more than 12+ booth design templates so that attendees can visit the booths that interest them, network, and take action.",
                });
              }
            } else if (row.Name == "Attendee") {
              this.attendeeFlg = row.selected == true ? true : false;
              this.attendeeColor = row.color == null ? null : row.color;
              if (this.attendeeFlg == true) {
                this.steps.splice(3, 0, {
                  target: "#v-step-3",
                  header: { title: "Create an Attendee" },
                  params: { placement: "right" },
                  offset: -200,
                  content: `Start by inviting attendees to your event. You can update avatar, name, email, headline, bio, and social profiles. You can also use the bulk import option and send bulk mails to attendees after you have added them!`,
                });
              }
            } else if (row.Name == "Speaker") {
              this.speakerFlg = row.selected == true ? true : false;
              this.speakerColor = row.color == null ? null : row.color;
              if (this.speakerFlg == true) {
                this.steps.splice(4, 0, {
                  target: "#v-step-4",
                  header: { title: "Create a Speaker" },
                  offset: -200,
                  params: { placement: "right" },
                  content:
                    "Adding Speakers brings more structure and makes the event more informative to the attendees. Once the speaker profile has been saved, it will automatically be displayed in the speaker section of the event page and inside the session details.",
                });
              }
            } else if (row.Name == "1:1 Meetings") {
              this.meetingFlg = row.selected == true ? true : false;
              this.meetingColor = row.color == null ? null : row.color;
              if (this.meetingFlg == true) {
                this.steps.splice(5, 0, {
                  target: "#v-step-5",
                  header: { title: "Enable 1:1 Meetings" },
                  offset: -200,
                  params: { placement: "right" },
                  content:
                    "By enabling the one to one meeting, attendees are able to initiate one-on-one video calls with other attendees as per the confirmed meeting slots booked in advance",
                });
              }
            } else if (row.Name == "Sponsor") {
              this.sponserFlg = row.selected == true ? true : false;
              this.sponsorColor = row.color == null ? null : row.color;
              if (this.sponserFlg == true) {
                this.steps.splice(6, 0, {
                  target: "#v-step-6",
                  header: { title: "Create a Sponsor" },
                  offset: -200,
                  params: { placement: "right" },
                  content:
                    "Here you can add sponsors and group them under categories such as Gold/Silver. They will be displayed as per your preferred order in the Sponsor screen of the events platform.",
                });
              }
            } else if (row.Name == "Lobby") {
              this.lobbyFlg = row.selected == true ? true : false;
              this.lobbyColor = row.color == null ? null : row.color;
              if (this.lobbyFlg == true) {
                this.steps.splice(7, 0, {
                  target: "#v-step-7",
                  header: { title: "Virtual Lobby" },
                  offset: -200,
                  params: { placement: "right" },
                  content:
                    "The virtual lobby is the gateway to your virtual event. Once attendees log in to the lobby they can see their agenda and easily join sessions. A virtual lobby is the perfect place to showcase your event’s sponsors and participating brands.",
                });
              }
            }
          });
          this.steps.splice(8, 0, {
            target: "#v-step-8",
            header: { title: "Setup Announcement Mail" },
            offset: -200,
            params: { placement: "left" },
            content:
              "Announcement mail is used to inform attendees of an important info related to the event. eg Event starts in 15 mins",
          });

          this.steps.splice(9, 0, {
            target: "#v-step-9",
            header: { title: "Setup Welcome Mail" },
            offset: -200,
            params: { placement: "left" },
            content:
              "Welcome Mail is sent after attendees self-register from the e2m Registration portal. Welcome mail usually has the login details with passcode in the mail body.",
          });

          this.steps.splice(10, 0, {
            target: "#v-step-10",
            header: { title: "Setup Attendee Reminder Mail" },
            offset: -200,
            params: { placement: "left" },
            content:
              "Reminder mail is used to send message out to attendees with Call to Action what you'd like them to do. eg Event starts in 15 mins: Login Now",
          });

          this.steps.splice(11, 0, {
            target: "#v-step-11",
            header: { title: "Setup Speaker Reminder Mail" },
            offset: -200,
            params: { placement: "left" },
            content:
              "Speaker mail template is used to send general information to speakers from the Speaker List screen.",
          });

          this.steps.splice(12, 0, {
            target: "#v-step-12",
            header: { title: "Manage menu" },
            offset: -200,
            params: { placement: "left" },
            content:
              "Manage Features by enabling or disabling top menu and left menu for Web and Mobile Apps.",
          });

          this.steps.splice(13, 0, {
            target: "#v-step-13",
            header: { title: "Manage Resources" },
            offset: -200,
            params: { placement: "left" },
            content:
              "Upload Images, PDFs, PPTs, DOCs, CSVs and much more and create a central knowledge repository for your event.",
          });

          this.steps.splice(14, 0, {
            target: "#v-step-14",
            header: { title: "Plugins" },
            offset: -200,
            params: { placement: "left" },
            content:
              "With the help of plugins, extend functionality or add new features to your virtual/hybrid event experience for attendees.",
          });

          this.steps.splice(15, 0, {
            target: "#v-step-15",
            header: { title: "Notification" },
            offset: -200,
            params: { placement: "left" },
            content:
              "Create messages and send them in real-time or schedule it in future date & time targeting a group of attendees or all in the event or specific attendees.",
          });
        });
    },
    fetchAllCounts() {
      this.$store
        .dispatch("dashboardManagement/fetchAllDashboardStats")
        .then((res) => {
          this.attendeeCount = res.data[0].attendeeCount;
          this.speakerCount = res.data[0].speakerCount;
          this.sponserCount = res.data[0].sponsorCount;
          this.sessionCount = res.data[0].sessionCounts;
          this.roundtableCount = res.data[0].roundTableCount;
          this.exhibitorCount = res.data[0].exhibitorCount;
          this.meetingCount = res.data[0].meetingCount;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    pushToPage(page) {
      this.$router.push(page);
    },
    openMailTemplate(mailName, colName) {
      var mail = {};
      (mail.DocName = mailName), (mail.CollectionName = colName);
      bus.$emit("openMailTemp", mail);
      this.mailPopUp = true;
    },
    fetchEventInfo() {
      var self = this;
      return new Promise((resolve, reject) => {
        let docObj = new Object();
        eventInfoRef.get().then(function (doc) {
          self.allowRegistrationFlg =
            doc.data().AllowRegistration == null
              ? false
              : doc.data().AllowRegistration;
          var customDomain = ls.getSessionValueByKey("CustomDomain");
          if (customDomain != null) {
            self.registrationLink =
              "https://" +
              ls.getSessionValueByKey("CustomDomain") +
              "/event/" +
              doc.data().EventId;
          }
          self.EventIsPublished = doc.data().IsPublished ? true : false;
          self.IsEventDataLoaded = true;
          self.showUnPublishBanner = doc.data().IsPublished ? true : false;
        });
      });
    },
    copyLinkRegistration(data) {
      // $("#reglink").val(data);
      var ct = document.getElementById("reglink");
      ct.select();
      ct.setSelectionRange(0, 99999);
      document.getElementById("custom-tooltip-reg").style.display = "inline";
      document.execCommand("copy");
      setTimeout(function () {
        document.getElementById("custom-tooltip-reg").style.display = "none";
      }, 1000);
    },
    showSettings(setting) {
      if (setting == "Attendee") {
        this.attendeeKey += 1;
        this.attendeeSettings = true;
      } else if (setting == "Speaker") {
        this.speakerKey += 1;
        this.speakerSettings = true;
      } else if (setting == "Roundtable") {
        this.roundtableKey += 1;
        this.roundtableSettings = true;
      } else if (setting == "Session") {
        this.sessionKey += 1;
        this.sessionSettings = true;
      } else if (setting == "Exhibitor") {
        this.exhibitorKey += 1;
        this.exhibitorSettings = true;
      }
    },
    openSessionDropdown(e) {
      this.sessionDropdown = true;
      e.stopPropagation();
    },
    sendToSession(sessionType) {
      this.$router.push({
        name: "session-add",
        params: {
          sessionType: sessionType,
        },
      });
    },
    hidePopup() {
      this.sessionDropdown = false;
    },
    preventSessionPopupHide(e) {
      e.stopPropagation();
    },
    beforeUnPublishConfirmation() {
      vm = this;
      if (vm.EventIsPublished == true) {
        const { value: text } = Swal.fire({
          title: "Do you want to Unpublish the event?",
          input: "text",
          inputPlaceholder: "Type 'unpublish' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase() == "unpublish") {
              vm.EventIsPublished = false;
              vm.changeEventStatus();
            } else {
              return "Try again! Please type 'unpublish' and hit Submit.";
            }
          },
        }).then(function (result) {
          if (result.dismiss != null) {
            vm.EventIsPublished = true;
          }
        });
      } else {
        vm.EventIsPublished = true;
        vm.changeEventStatus();
        vm.fetchEventInfo();
      }
    },
    changeEventStatus() {
      this.$vs.loading();
      this.$store
        .dispatch("eventManagement/changeStatus", {
          IsPublished: vm.EventIsPublished,
          id: vm.Session_Event_Id,
        })
        .then((res) => {
          this.$vs.loading.close();
          vm.fetchEventInfo();
          if (res.status == 200) {
            if (vm.EventIsPublished == true) {
              let Session_EndTime = ls.getSessionValueByKey(
                "Session_EventEndDate"
              );

              if (new Date(Session_EndTime).getTime() >= new Date().getTime()) {
                vm.disablePreviewBtn = false;
              } else {
                vm.disablePreviewBtn = true;
              }
              vm.publishEventSuccess = true;
            } else {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                //title: "Round Table",
                text: "Event Status Changed Successfully.",
              });
            }
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Round Table",
              text: "Event Status Not Changed!",
            });
          }
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            //title: "Round Table",
            text: "Something Went Wrong!",
          });
        });
    },

    fetchGeneralSettings(){
      return new Promise((resolve, reject) => {
        this.$store.dispatch("eventManagement/fetchEvent", ls.getSessionValueByKey("Session_Event_Id")).then(res=>{
          this.GeneralSettings = res.data;
          resolve(true)
        })
      })
    },
  },
  components: {
    MailTemplateEdit,
    AttendeeSettings,
    SpeakerSettings,
    RtSettings,
    SessionSettings,
    ExhibitorSettings,
  },
  beforeRouteLeave: function (to, from, next) {
    if (setOverviewWatch) {
      clearInterval(setOverviewWatch);
    }
    next(true);
  },
  computed: {
    newVersionRegLink(){
      let registrationLink = `https://${ls.getSessionValueByKey("CustomDomain")}/event/${ls.getSessionValueByKey("Session_Event_Id")}`
      if(this.GeneralSettings.RegistrationVersion == 3){
        let version = Number(this.GeneralSettings.RegistrationVersion);
        return registrationLink.replace("event", "eventv"+version);
      }else{
        return registrationLink;
      }
    },    
  },
  watch: {
    /*EventIsPublished(val){
      if(this.IsEventDataLoaded)
        this.changeEventStatus();
    }*/
  },

  mounted() {
    vm = this;
    $(document).ready(function () {
      $(document).mousemove(function (event) {
        counter = 0;
      });
    });
    $(document).mouseup(function (e) {
      var popup = $("#sessionDropdown");
      if (
        !$("#sessionDropdown").is(e.target) &&
        !popup.is(e.target) &&
        popup.has(e.target).length == 0
      ) {
        popup.hide(500);
      }
    });

    if (vm.$route.path.includes("tour")) {
      vm.$tours["myTour"].start();
    }

    setOverviewWatch = setInterval(function () {
      counter += 10;
      if (counter == 300) {
        alert("Please click 'OK' to keep working");
      } else {
        vm.fetchAllCounts();
      }
    }, 30000);
    vm.showResponsivePreview();
  },
  created() {
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    this.fetchEventMenuData();
    this.fetchEventInfo();
    if (!moduleDashboardManagement.isRegistered) {
      this.$store.registerModule(
        "dashboardManagement",
        moduleDashboardManagement
      );
      moduleDashboardManagement.isRegistered = true;
    }
    if (!moduleMailtplManagement.isRegistered) {
      this.$store.registerModule("mailtplManagement", moduleMailtplManagement);
      moduleMailtplManagement.isRegistered = true;
    }
    this.fetchAllCounts();
    this.fetchGeneralSettings();
    bus.$on("startTour", (data) => {
      this.$tours["myTour"].start();
    });
  },
};
</script>